module.exports = __webpack_public_path__ + "img/S__90480902.d6c6b26a.jpg";